import { EFaceType } from '../type';
import { ContourFaceModel } from './faceModel/contourFaceModel';
import { EEntityType, EFaceSide } from '@/editor/types';
import { EContainerType } from '@/editor/types/entity';
import { EFaceDataBaseType } from '@/editor/data/face/face';
import { getPathFromEdges } from '@/editor/utils/edge';
import { RoomData } from '@/editor/data/room/Room';
import { globalStores } from '@/editor/stores';

function translateRoomToBaseData(roomData: RoomData) {
  return {
    contour: getPathFromEdges(roomData.pathInfos),
    offGround: roomData.height + roomData.offGround
  };
}

class CeilModel extends ContourFaceModel {
  constructor(roomData: RoomData) {
    super({ id: roomData.id });

    // 覆盖face中的数据
    this.model.userData.type = EEntityType.Ceil;
    this.model.userData.containerType = EContainerType.entity;
    this.model.userData.entityId = this._id;

    this.createCeilModel(roomData);
  }

  createCeilModel(roomData: RoomData) {
    super.createModel({
      id: roomData.id,
      materialInfo: globalStores.getDefaultMaterial(),
      type: EFaceType.RegionFace,
      baseData: translateRoomToBaseData(roomData),
      baseDataType: EFaceDataBaseType.Contour,
      relativeInfo: { side: EFaceSide.BottomSide }
    });
  }
}

export default CeilModel;
